import Vue from "vue";
import Vuetify from "vuetify";
import colors from "vuetify/es5/util/colors";
import Toast from "vue-toastification";
import VCurrencyField from 'v-currency-field'

import "vue-toastification/dist/index.css";
import "vuetify/dist/vuetify.min.css";




Vue.use(Vuetify);

Vue.use(Toast, {
  position: 'top-center',
  transition: "Vue-Toastification__fade",
  closeOnClick: false,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  closeButton: false,
  hideProgressBar: true,
  icon: true,
});


Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true
})


export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: true, // Mudança aqui para false, indicando o tema light
    themes: {
      dark: { // Novo objeto para o tema light
        primary: colors.amber.accent3, // #E53935
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base, // #3F51B5
      },
    },
  },
})
